import React, {useEffect, useState} from "react"
import api from "../services/apiClient";
import AuthService from '../services/authentication'

import { Button, Input, Label, InputGroup } from "../ui"


function SetMarkupForm(props) {

	const [markup, setMarkup] = useState(0)
	let auth = AuthService.useAuth()

	const handleInputChange = event => {
		const value = event.target.value
		setMarkup(value)
	}

	useEffect(() => {
	  api.get('/api/practitioner/markup', {headers: auth.authHeader()})
	  .then(response => {
	    setMarkup(response.data)
	  })
	  .catch(error => {
	    console.log(error)
	  })
	}, [])

	const handleSubmit = event => {
		event.preventDefault()
		api.post(`/api/practitioner/markup`,
		  {
		    markup: markup
		  },
		  {
		    headers: auth.authHeader(),
		  }
		)
		.then(response => {
		  console.log(response)
		})
		.catch(error => {
		  console.log(error)
		})
	}

	return (
		<form onSubmit={handleSubmit}>
		  	<Label>Set your default markup rate</Label>
		  	<InputGroup>
		  	    <Input name="markup" type="number" placeholder="0" onChange={e => e.target.value >= 0 && e.target.value <= 300 && handleInputChange(e)} value={markup} min={0} step={0.01} />
		  	    <InputGroup.Text>%</InputGroup.Text>
		  	    <Button variant="secondary" type="submit">Save</Button>
		  	</InputGroup>
		    <p id="passwordHelpBlock" className="text-sm text-gray-500">
		    	This can be overidden on a per order basis.
		    </p>
		</form>
	)
}

export default SetMarkupForm